import React, { lazy, Suspense, useContext } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useHistory,
} from 'react-router-dom';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { useAuth0 } from './auth0-wrapper';
import { tenantContext } from './TenantProvider';
import { hasRole, ROLES } from './components/common/access-control/rbac';

const AdminApp = lazy(() => import('./components/admin-portal/AdminApp'));
const TenantApp = lazy(() => import('./components/tenant-portal/TenantApp'));
const NotFound = lazy(() => import('./components/error-pages/NotFound'));

const ALL_TENANTS_QUERY = gql`
  query ALL_TENANTS_QUERY {
    tenants {
      id
      name
    }
  }
`;
// A custom hook that builds on useLocation to parse
// the query string for you.
const useSearchQuery = () => new URLSearchParams(useLocation().search);

const Routes = () => {
  const location = useLocation();
  const history = useHistory();
  const { user } = useAuth0();
  const dapClaims = user['https://dap.covis.de'] || {};
  const userTenantId = +dapClaims.tenant;
  const { tenantId: selectedTenantId, setTenantId } = useContext(tenantContext);

  const isPortalAdmin = hasRole(user, ROLES.PORTAL_ADMIN);

  let tenantIdParam = null;
  try {
    const query = useSearchQuery();
    tenantIdParam = parseInt(query.get('tenantId'));
  } catch (error) {
    console.log(error);
  }

  if (
    location.pathname.startsWith('/console') &&
    selectedTenantId &&
    !tenantIdParam
  ) {
    setTenantId(null);
  }

  const { loading } = useQuery(ALL_TENANTS_QUERY, {
    fetchPolicy: 'cache-and-network',
    skip:
      userTenantId ||
      !tenantIdParam ||
      tenantIdParam === '' ||
      tenantIdParam === null ||
      tenantIdParam === undefined,
    onCompleted: tenantsData => {
      if (tenantsData && tenantsData.tenants) {
        const ids = [];
        tenantsData.tenants.forEach(item => {
          ids.push(item.id);
        });
        if (tenantIdParam && ids.includes(tenantIdParam)) {
          setTenantId(tenantIdParam);
        }
        // Removed this because it looses the URL during refresh
        // else {
        //   history.push({ pathname: '/' });
        // }
      }
    },
  });
  if (loading) return <p>Loading...</p>;

  return (
    <Suspense fallback={<p>Loading...</p>}>
      <Switch>
        <Route path="/console" component={AdminApp} />
        <Route
          path="/"
          render={() =>
            isPortalAdmin && !selectedTenantId && !tenantIdParam ? (
              <Redirect to="/console" />
            ) : (
              <TenantApp />
            )
          }
        />
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Routes;
